// Infrastructure implementation of the ServiceContainer
// This is where we wire up concrete Firebase implementations

import { ServiceContainer } from '../../domain/ports/ServiceContainer';

// Adapters (Ports implementations)
import { FirebaseAccountAdapter } from '../adapters/FirebaseAccountAdapter';
import { FirebaseAlertManagementAdapter } from '../adapters/FirebaseAlertManagementAdapter';
import { FirebaseDataAdapter } from '../adapters/FirebaseDataAdapter';
import { FirebaseLocationManagementAdapter } from '../adapters/FirebaseLocationManagementAdapter';
import { FirebaseOrganizationManagementAdapter } from '../adapters/FirebaseOrganizationManagementAdapter';
import { FirebaseOrganizationAddressBookAdapter } from '../adapters/FirebaseOrganizationAddressBookAdapter';
import { FirebaseSensorManagementAdapter } from '../adapters/FirebaseSensorManagementAdapter';
import { FirebaseUserManagementAdapter } from '../adapters/FirebaseUserManagementAdapter';

// Repositories
import { FirebaseAlertRepository } from '../repositories/FirebaseAlertRepository';
import { FirebaseEventRepository } from '../repositories/FirebaseEventRepository';
import { FirebaseLocationRepository } from '../repositories/FirebaseLocationRepository';
import { FirebaseOrganizationRepository } from '../repositories/FirebaseOrganizationRepository';
import { FirebaseSensorRepository } from '../repositories/FirebaseSensorRepository';
import { FirebaseUserRepository } from '../repositories/FirebaseUserRepository';

import { FirebaseAuthAdapter } from '../adapters/FirebaseAuthAdapter';

// Services
import { LoggerService } from '../../domain/services/LoggerService';

export class FirebaseServiceContainer implements ServiceContainer {
  // Singleton instances
  private static instance: FirebaseServiceContainer;
  
  // Services
  public readonly loggerService = new LoggerService();
  
  // Ports
  public readonly accountPort = new FirebaseAccountAdapter(this.loggerService);
  public readonly alertManagementPort = new FirebaseAlertManagementAdapter(this.loggerService);
  public readonly dataPort = new FirebaseDataAdapter(this.loggerService);
  public readonly locationManagementPort = new FirebaseLocationManagementAdapter(this.loggerService);
  public readonly organizationManagementPort = new FirebaseOrganizationManagementAdapter(this.loggerService);
  public readonly organizationAddressBookPort = new FirebaseOrganizationAddressBookAdapter(this.loggerService);
  public readonly sensorManagementPort = new FirebaseSensorManagementAdapter(this.loggerService);
  public readonly userManagementPort = new FirebaseUserManagementAdapter(this.loggerService);
  
  // Repositories
  public readonly alertRepository = new FirebaseAlertRepository(this.loggerService);
  public readonly eventRepository = new FirebaseEventRepository(this.loggerService);
  public readonly locationRepository = new FirebaseLocationRepository(this.loggerService);
  public readonly organizationRepository = new FirebaseOrganizationRepository(this.loggerService);
  public readonly sensorRepository = new FirebaseSensorRepository(this.loggerService);
  public readonly userRepository = new FirebaseUserRepository(this.loggerService);
  
  public readonly authRepository = new FirebaseAuthAdapter(this.loggerService);
  
  private constructor() {
    // Private constructor for singleton pattern
  }
  
  public static getInstance(): FirebaseServiceContainer {
    if (!FirebaseServiceContainer.instance) {
      FirebaseServiceContainer.instance = new FirebaseServiceContainer();
    }
    return FirebaseServiceContainer.instance;
  }
}